import { generatePath } from './generate-paths';

const ASSORTMENT_ROOT = '/assortment';

export const ASSORTMENT_PATH_APP = {
  productLocations: generatePath(
    ASSORTMENT_ROOT,
    '/product/:productId/locations',
  ),
  locationProducts: generatePath(
    ASSORTMENT_ROOT,
    '/location/:locationId/products',
  ),
  inSeason: generatePath(ASSORTMENT_ROOT, '/in-season'),
} as const;
